import React from "react";
import { ChevronLeft, ChevronRight, Headphones } from "lucide-react";
import CardContainer from "../Containers/CardContainer";
import Header from "../Headers/Header";
import IndexNavigation from "../Navigation/IndexNavigation";
import SentenceCard from "./SentenceCard";
import BlockButton from "../Buttons/BlockButton";

const WordDisplayCard = ({
  text,
  subText,
  textNative,
  currentIndex,
  totalWords,
  onNext,
  onPrev,
  onListen,
}) => {
  return (
    <CardContainer className="p-8 text-center">
      <Header title={text} subtitle={subText} />

      <IndexNavigation
        currentIndex={currentIndex}
        totalCount={totalWords}
        onNext={onNext}
        onPrev={onPrev}
      />

      <SentenceCard
        header={"বাংলা অর্থ"}
        sentence={textNative}
        color="indigo"
        cardClassName="mb-4"
      />

      <BlockButton
        onClick={onListen}
        backgroundColor="bg-green-600"
        hoverBackgroundColor="bg-green-700"
        textColor="text-white"
        icon={<Headphones className="h-5 w-5" />}
        text="নির্দেশনা শুনুন"
      />
    </CardContainer>
  );
};

export default WordDisplayCard;
